import { Component, Vue } from "vue-property-decorator";
import Template from "./NotFound.template.vue";

@Component({
  mixins: [Template]
})
export default class NotFoundComponent extends Vue {
  public back() {
    this.$router.back();
  }
}
